module.exports = __webpack_public_path__ + "img/facebook.c453eb20.png";